import { useState, useEffect, useCallback } from "react";
import axiosConfig from "../../../services/Axios";
import Select from "react-select";
import SelectTheme from "./SelectTheme";
import SelectStyle from "./SelectStyle";

const SelectCategories = ({
  onChange,
  cancelToken = null,
  className,
  isClearable = false,
  isSearchable = true,
  parentCategory = null,
  isDisabled = false,
  value = null,
  emptyOpt = false,
  myRef = null,
}) => {
  const [options, setOptions] = useState();
  const [selectedValue, setSelectedValue] = useState();

  const fetchCategories = useCallback(async (token, parentCategory) => {
    return await axiosConfig
      .get(
        process.env.REACT_APP_API_URL +
          (parentCategory
            ? "/api/item_sub_categories?pagination=false&itemCategory=" +
              parentCategory
            : "/api/item_categories?pagination=false"),
        {
          cancelToken: token,
        }
      )
      .then((response) => {
        let categories = [];

        response.data["hydra:member"].map((categorie) => {
          categories.push({
            value: categorie["@id"],
            label: categorie.name,
          });
        });

        if (value || emptyOpt === false) {
          let selected = categories.filter((c) => c.value === value)[0];
          setSelectedValue(selected);
        }

        return categories;
      })
      .catch(function (thrown) {
        if (axiosConfig.isCancel(thrown)) {
          console.log("Categorie Request canceled : ", thrown.message);
        }
      });
  }, []);

  useEffect(() => {
    fetchCategories(cancelToken, parentCategory).then((response) => {
      setOptions(response);
    });
  }, [parentCategory, cancelToken]);

  useEffect(() => {
    setSelectedValue([]);
  }, [parentCategory]);

  return (
    <>
      <Select
        styles={SelectStyle}
        ref={myRef}
        isDisabled={isDisabled}
        isSearchable={isSearchable}
        isClearable={isClearable}
        options={options}
        value={selectedValue}
        onChange={(e) => {
          onChange(e && e?.value !== "" ? e.value : null);
          setSelectedValue(e ? e : null);
        }}
        className={`${className} react-select-container w-full`}
        theme={SelectTheme}
      />
    </>
  );
};

export default SelectCategories;
